import React, { useState } from 'react';
import '../App.css'
import { cityAttractionsService } from "../services/CityAttractionsService";
import { CityAttractionsContext } from "../contexts/CityAttractionsContext";


function LoadingOverlay() {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="loading-spinner w-12 h-12 rounded-full border-t-4 border-blue-500"></div>
    </div>
  );
}
function SeoForm(props) {
  const [word, setWord] = useState('');
  const [selectedTour, setSelectedTour] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { cityAttractionsState, dispatch } = React.useContext(CityAttractionsContext);
  const [isModalOpen, setModalOpen] = useState(false);

  const handleCardClick = (tour) => {
    setSelectedTour(tour);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedTour(null);
  };



  const handleSend = async () => {
    await cityAttractionsService.createarticle(dispatch, word);
  };

  

  const handleAllSend = async () => {
    await cityAttractionsService.createallarticles(dispatch);
  };


  return (
    <div className="flex flex-col items-center justify-center min-h-screen space-y-4">
      <div className="flex items-center space-x-4" style={{ marginTop: '20vh' }}>
        <input
          type="text"
          value={word}
          placeholder="Enter article topic..."
          onChange={(e) => setWord(e.target.value)}
          className="border-2 border-blue-500 p-3 rounded shadow-md text-xl"
          style={{ width: '100vh', height: '6vh' }}
        />
        <button className="button button-dimensions button--primary min-w-[8rem]" onClick={handleSend}>
          Create
        </button>

        <button className="button button-dimensions button--primary min-w-[8rem]" onClick={handleAllSend}>
          Generate ALL articles
        </button>
        {cityAttractionsState.loading && <LoadingOverlay />}
      </div>
      {cityAttractionsState.article!="" && <div className="mx-auto mb-4 p-6 border rounded-lg flex flex-col items-center justify-center w-full h-full" style={{ maxWidth: '150vh', maxHeight: '150vh' }}><textarea className="w-full  h-96" value={cityAttractionsState.article} /></div>}
      
    </div>
  );
}

export default SeoForm;